<template>
  <div>
    <div class="text-xs-center" v-if="linear">
      <v-flex d-flex align-center>
        <v-progress-linear class="" v-model="completion" :color="themes.client.light.secondary" height="6"/>
        <v-chip small class="caption d-flex accent">{{completion }}%</v-chip>
      </v-flex>
    </div>
    <v-progress-circular :value="completion" :color="themes.client.light.secondary" :size="size" :width="4" :rotate="-90" v-else>
      <v-avatar class="transparent" :size="size-10" v-if="avatar">
        <img :src="avatar">
      </v-avatar>
      <v-avatar class="transparent" :size="size-10" v-else>
        <img src="/img/missing/logos/institutions/original.png">
      </v-avatar>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    start: String,
    end: String,
    size: [Number, String],
    avatar: String,
    linear: Boolean
  },
  computed: {
    completion() {
      const start = this.start ? new Date(this.start) : new Date()
      const end = this.end ? new Date(this.end) : new Date()

      if (end > new Date()) {
        return Math.round((Math.abs(end - new Date()) / Math.abs(end - start)) * 100)
      }
      return 100
    }
  }
}
</script>
